import React, { createContext, useContext, useMemo, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { GetRulesByCompany } from '../graphql/rules';
import { CompanyContext } from 'src/context';

const RulesContext = createContext({
  rules: [],
  loading: false,
  error: null,
  refetchRules: () => {},
});

export const RulesProvider = ({ children }) => {
  const companyCtx = useContext(CompanyContext);
  const { selectedCompany } = useSelector((state) => state.companyList);
  // Prefer CompanyContext (used by Configuracion2) and fallback to Redux (used elsewhere).
  const companyId = companyCtx?.selectedCompany?.id || selectedCompany?.id;
  const hasMounted = useRef(false);

  const { data, fetching, error, executeQuery } = GetRulesByCompany({
    companyId
  });

  // Refetch rules when company changes (skip initial mount — urql already fires on mount)
  useEffect(() => {
    if (companyId && hasMounted.current) {
      executeQuery({ requestPolicy: 'network-only' });
    }
    hasMounted.current = true;
  }, [companyId]);

  const value = useMemo(() => ({
    rules: data?.getRulesByCompany?.rules || [],
    loading: fetching,
    error,
    refetchRules: executeQuery,
  }), [data, fetching, error, executeQuery]);

  return (
    <RulesContext.Provider value={value}>
      {children}
    </RulesContext.Provider>
  );
};

export const useRules = () => {
  const context = useContext(RulesContext);
  if (!context) {
    throw new Error('useRules must be used within RulesProvider');
  }
  return context;
};

